import { MapUtils } from '../../../../../utility/map-utils.js';
import { cloneData, isSameData } from '../../../../dto/data-model-utils.js';
import {
  SerializedData, SerializationContext, DataModelBuilder,
} from '../../../../dto/data-model.js';
import { OnlineEventTicketOrder } from '../../../online-event-ticket-order.js';
import { AuditLogEntryType } from '../../audit-log-entry-type.js';
import { AuditLogEntry } from '../../audit-log-entry.js';

export class SeatedOnlineEventTicketSwapEntry extends AuditLogEntry {
  static readonly TYPE_ID: string = '4d426a5670d04e208c9451001b35bdc6';

  private constructor(
    public readonly ticketId: string,
    public readonly oldSeatId: number,
    public readonly newSeatId: number,
    public readonly before: OnlineEventTicketOrder,
    public readonly after: OnlineEventTicketOrder,
  ) {
    super();
  }

  get type(): AuditLogEntryType {
    return AuditLogEntryType.SeatedOnlineEventTicketSwap;
  }

  generateQueryData(): SerializedData {
    return {
      businessRef: this.after.businessRef.encode(),
      eventId: this.after.eventId,
      orderId: this.after.uniqueId,
      ticketId: this.ticketId,
    };
  }

  get $typeId(): string {
    return SeatedOnlineEventTicketSwapEntry.TYPE_ID;
  }

  static create(args: {
    ticketId: string,
    oldSeatId: number,
    newSeatId: number,
    before: OnlineEventTicketOrder,
    after: OnlineEventTicketOrder,
  }): SeatedOnlineEventTicketSwapEntry {
    return new SeatedOnlineEventTicketSwapEntry(
        args.ticketId,
        args.oldSeatId,
        args.newSeatId,
        args.before,
        args.after,
    );
  }

  static fromMap(context: SerializationContext, map: SerializedData): SeatedOnlineEventTicketSwapEntry {
    return this.create({
      ticketId: MapUtils.getString(map, 'ticketId'),
      oldSeatId: MapUtils.getNumber(map, 'oldSeatId'),
      newSeatId: MapUtils.getNumber(map, 'newSeatId'),
      before: context.fromData<OnlineEventTicketOrder>(MapUtils.getRecord(map, 'before')),
      after: context.fromData<OnlineEventTicketOrder>(MapUtils.getRecord(map, 'after')),
    });
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      ticketId: this.ticketId,
      oldSeatId: this.oldSeatId,
      newSeatId: this.newSeatId,
      before: context.toData(this.before),
      after: context.toData(this.after),
    };
  }

  clone(): this {
    return new SeatedOnlineEventTicketSwapEntry(
        this.ticketId,
        this.oldSeatId,
        this.newSeatId,
        cloneData(this.before),
        cloneData(this.after),
    ) as this;
  }

  isSame(other: this): boolean {
    if(other === this) {
      return true;
    }

    return other.ticketId === this.ticketId &&
            other.oldSeatId === this.oldSeatId &&
            other.newSeatId === this.newSeatId &&
            isSameData(other.before, this.before) &&
            isSameData(other.after, this.after);
  }
}

export class SeatedOnlineEventTicketSwapEntryBuilder extends DataModelBuilder<SeatedOnlineEventTicketSwapEntry> {
  build(context: SerializationContext, map: SerializedData): SeatedOnlineEventTicketSwapEntry {
    return SeatedOnlineEventTicketSwapEntry.fromMap(context, map);
  }
}
